import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';

const timestamp = new Date().toISOString();

export default function usePastClaims(props) {
  const currentUser = useUser();

  return useConnect('claim.find', {
    where: {
      eager: {
        $where: {
          userId: currentUser.id,
          response: 'Connect',
          $or: [
            {
              offer: {
                $where: {
                  completed: true
                }
              }
            },
            {
              offer: {
                $where: {
                  cancelled: true
                }
              }
            },
            {
              offer: {
                $where: {
                  $and: [
                    {
                      specificDate: 'Yes'
                    },
                    {
                      date: {
                        $lte: timestamp
                      }
                    }
                  ]
                }
              }
            },
            {
              offer: {
                $where: {
                  $and: [
                    {
                      specificDate: 'No'
                    },
                    {
                      endDate: {
                        $lte: timestamp
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  });
}
